var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pr-item",class:_vm.variant},[_c('div',{staticClass:"recuento-container"},[_c('div',[_c('b',[_vm._v(_vm._s(_vm.caption))])]),_c('span',{staticClass:"recuento"},[_vm._v(_vm._s(_vm.recuento))]),_vm._v(" / "),_c('span',{staticClass:"promedio-value"},[_vm._v(_vm._s(_vm.promedio)+" días")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }